module.exports = __webpack_public_path__ + "img/case1.fcd73b17.jpg";